import React from 'react';
import { useBranch } from '../context/BranchContext';

const BranchSelector = ({ className = '', showLabel = true }) => {
  const { selectedBranch, branches, loading, error, selectBranch, branchNotice, dismissBranchNotice } =
    useBranch();

  const handleBranchChange = (e) => {
    const branchId = e.target.value;
    if (!branchId) {
      selectBranch(null);
      return;
    }
    const branch = branches.find((b) => b.id === branchId);
    if (branch) {
      selectBranch(branch);
    }
  };

  if (loading) {
    return (
      <div className={`branch-selector ${className}`}>
        {showLabel && <label className="branch-label">Chi nhánh:</label>}
        <div className="branch-loading">Đang tải...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`branch-selector ${className}`}>
        {showLabel && <label className="branch-label">Chi nhánh:</label>}
        <div className="branch-error">Lỗi tải danh sách chi nhánh</div>
      </div>
    );
  }

  // #120936 — cảnh báo khi `?branch_id=` trên URL bị bỏ qua (luật 3c của khuôn deep-link).
  // Phải NHÌN THẤY ĐƯỢC, không được chỉ log console. Đặt ở đây vì BranchSelector có mặt trên
  // mọi trang dùng chi nhánh.
  const notice = branchNotice ? (
    <div
      className="branch-notice"
      role="alert"
      title={branchNotice}
      style={{ color: '#b54708', fontSize: 12, marginTop: 4 }}
    >
      <i className="icofont-warning-alt"></i> {branchNotice}{' '}
      <button
        type="button"
        onClick={dismissBranchNotice}
        style={{ border: 0, background: 'none', textDecoration: 'underline', padding: 0 }}
      >
        Bỏ qua
      </button>
    </div>
  ) : null;

  // Nếu chỉ có 1 branch, hiển thị thông tin branch thay vì dropdown
  if (branches.length === 1) {
    return (
      <div className={`branch-selector single-branch ${className}`}>
        {showLabel && <label className="branch-label">Chi nhánh:</label>}
        <div className="branch-info">
          <i className="icofont-building"></i>
          <span className="branch-name">{branches[0].name}</span>
          <span className="branch-code">({branches[0].code})</span>
        </div>
        {notice}
      </div>
    );
  }

  return (
    <div className={`branch-selector ${className}`}>
      {showLabel && <label className="branch-label">Chi nhánh:</label>}
      <select
        value={selectedBranch?.id || ''}
        onChange={handleBranchChange}
        className="branch-dropdown"
      >
        <option value="">-- Tất cả chi nhánh --</option>
        {branches.map((branch) => (
          <option
            key={branch.id}
            value={branch.id}
          >
            {branch.name} ({branch.code})
          </option>
        ))}
      </select>
      {notice}
    </div>
  );
};

export default BranchSelector;
